import { Dialog, DialogTitle, DialogContent, Button, Box, Typography, Grid, IconButton, TextField, Autocomplete, FormHelperText, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import React, { useState } from 'react';
import AddABG from './AddABG';
import AddPBG from './AddPBG';
import AddRBG from './AddRBG';
import { useDispatch } from 'store';
import { RxCross2 } from "react-icons/rx";
import { useParams } from "react-router-dom";
import { FINANCIALBG_TYPES } from "config";

const AddFinancialBG = (props) => {
    const { open, handleClose } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();
    const [type, setType] = useState("ABG");

    const filteredTypes = FINANCIALBG_TYPES;

    const handleSubmit = async ({ values, mapper }) => {
        console.log("final submit", values, mapper)
    };

    return (
        <>
            <Dialog open={open}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                }}>
                    <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                        Add Financial BG
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose()}
                        sx={(theme) => ({
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <RadioGroup
                        row
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                        sx={{mb: 2}}
                    >
                        {filteredTypes.map((t) => (
                            <FormControlLabel
                                key={t.value}
                                value={t.value}
                                control={<Radio />}
                                label={t.label}
                            />
                        ))}
                    </RadioGroup>

                    {type === "ABG" && <AddABG tabKey="ABG" handleClose={handleClose} />}
                    {type === "PBG" && <AddPBG tabKey="PBG" handleClose={handleClose} />}
                    {type === "RBG" && <AddRBG tabKey="RBG" handleClose={handleClose} />}
                    
                </DialogContent>
            </Dialog>
        </>
    )
}

export default AddFinancialBG
